export default __webpack_public_path__ + "static/media/eye-closed.31929dcf.svg";